import request from '@/utils/request'

export function pageLiveCourseChapter(data) {
  return request({
    url: '/livecourse/liveCourseChapter/page',
    method: 'post',
    data: data
  })
}

export function listLiveCourseChapter(query) {
  return request({
    url: '/livecourse/liveCourseChapter/list',
    method: 'get',
    params: query
  })
}

export function addLiveCourseChapter(data) {
  return request({
    url: '/livecourse/liveCourseChapter/add',
    method: 'post',
    data: data
  })
}

export function updateLiveCourseChapter(data) {
  return request({
    url: '/livecourse/liveCourseChapter/edit',
    method: 'post',
    data: data
  })
}

export function delLiveCourseChapter(data) {
  return request({
    url: '/livecourse/liveCourseChapter/delete',
    method: 'post',
    data: data
  })
}
